import React, { FC, useState, useEffect } from "react";
import { ToggleButton } from "react-bootstrap";

import "./toggleButton.scss";

interface Props {
    isToggle?: boolean | any;
    handleToggle?: () => void ;
    handleClick? :()=>void 
}

const ToogleButton: FC<Props> = ({ isToggle, handleToggle,handleClick }) => {

    /* console.log(isToggle) ;  */
    return (
        <div className="toggle">
            <label>
                <input id="checkbox" type="checkbox" className="Checkbox" defaultChecked={isToggle} onClick={handleClick}  value={isToggle} /> 
                <span></span>
            </label>
        </div>
    )
}
export default ToogleButton; 